import { CURRENT_CLIENT } from '@/constants'

/** Site title + year — shared by marketing landing and public share pages. */
export function MarketingSiteFooter() {
  const siteTitle = (CURRENT_CLIENT as { siteTitle?: string }).siteTitle || CURRENT_CLIENT.name

  return (
    <p>
      {siteTitle} · {new Date().getFullYear()}
    </p>
  )
}
